/**
 * Dashboard（/app/welcome）。菜单 Dashboard。
 * 打开页面打 STATSIG.COMMON.VIEW，value=dashboard。
 *
 * 当前页面在用的功能：
 * - 新手引导（Owner 另有 Lodestar / Manager setup）
 * - 最近贷款列表
 * - Strata AI 入口
 * - Bluerate 上线弹窗、定价推荐弹窗
 *
 * 已注释、不算在用：Overview / Rate selection / Borrower tasks
 */
export enum DashboardEvent {
    /**
     * Hide / Display setup guide。
     * value=open|hide
     */
    HIDE_SETUP_GUIDE = 'DASHBOARD_HIDE_SETUP_GUIDE',
    /**
     * 点击引导区任意功能卡片。
     * value：有跳转则是 path；弹窗（如 Manager setup）则是 item 名。
     * metadata.item 见 dashboardFeatureItem()
     */
    FEATURES_ITEM_CLICK = 'DASHBOARD_FEATURES_ITEM_CLICK',
    /** 打开最近贷款 */
    RECENT_LOANS_OPEN = 'DASHBOARD_RECENT_LOANS_OPEN',
    /**
     * Strata AI 入口。
     * 属性 type=demo|try
     */
    STRATA = 'DASHBOARD_STRATA',
    /** Bluerate 上线弹窗：访问主页 */
    BLUERATE_OPEN = 'DASHBOARD_BLUERATE_OPEN',
    /** 定价推荐弹窗：查看定价 */
    PRICING_OPEN = 'DASHBOARD_PRICING_OPEN',
}

const DASHBOARD_FEATURE_ITEM = {
    lodestar: 'lodestar',
    addBorrower: 'manager_setup',
    completeProfile: 'profile',
    tryPricingEngine: 'pricing',
    tryMortgageGPT: 'guideline',
    tryAffordabilityCalculator: 'affordability',
    setUpWebsite: 'website',
} as const

export function dashboardFeatureItem(itemKey: string): string | undefined {
    return DASHBOARD_FEATURE_ITEM[itemKey as keyof typeof DASHBOARD_FEATURE_ITEM]
}
